import { SESSION_HEARTBEAT } from "./endpoints";
export const for_loader = [
    SESSION_HEARTBEAT
]